export default async (basket_data, shopify_instance) => {
  if(basket_data.length === 0) return resolve(...basket_data)

  const array_of_products = await Promise.all(
    basket_data.map(({ id }) => shopify_instance.product.fetch(id))
  )

  return array_of_products
}
